export const TERMS_URL = 'https://www.higo.io/terminos-y-condiciones';
export const PRIVACY_POLICY_URL = 'https://higo.io/aviso-de-privacidad';
